import {
  Button,
  Box,
  createStyles,
  Text,
  Select,
  TextInput,
  Modal,
  Drawer,
  ScrollArea,
  Accordion,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { IconChevronDown } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { useForm } from "@mantine/form";

import swal from "sweetalert";

import {
  createBillingProvider,
  getBillingProvider,
} from "../../services/billingprovider";
// import { showError } from "../../utils";
import { stateZipCodes } from "../../utils/zipCodes";
import ProviderServiceSearch from "./ProviderServiceSearch";

const useStyles = createStyles(() => ({
  mainbox: {
    background: "#FFFF",
    width: "100%",
    padding: "13px 19px",
    borderRadius: "16px",
    marginTop: "15px",
  },

  lookupflex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  drawer: {
    backgroundColor: "#F5F5F5 !important",
  },

  // customBox: {
  //   'mantine-1q36a81:not(:only-child)': {
  //     background:'#F5F5F5',
  //      paddingTop:'15px'
  //   },

  customBox: {
    backgroundColor: "#F5F5F5",
    //  paddingTop: '15px',
    "& .mantine-1ajh50z": {
      backgroundColor: "#F9FAFB",
    },
  },

  addbox: {
    // padding: "12px 12px 20px 30px",
    borderRadius: "12px",
    // border: "1px solid #E5E5EA",
    background: "#FFF",
  },

  formRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
    "@media (max-width:1300px)": {
      flexDirection: "column",
      gap: "10px",
    },

    mt19: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },
  },
  selectnumber: {
    width: "20%",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,

    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      borderRadius: "8px",
      // border: "1px solid #E5E5E5",
      border: "1px solid #D5D7DA",
      paddingInline: 0,
    },
  },

  selectbilling: {
    width: "70px",
    padding: "5px 5px",
    // borderRadius: "5px",
    backgroundColor: bgColor,
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  selecttext: {
    width: "200px",
    padding: "5px 15px",
    // borderRadius: "5px",
    backgroundColor: bgColor,
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  dflex: {
    display: "flex",
    justifyContent: "space-between",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  addservicebtn: {
    // marginTop: "20px",
    width: "100%",
    borderRadius: "12px",
    border: "2px solid #E5E5E5",
    textAlign: "left",
    padding: "20px 26px",
    alignItems: "flex-start",
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",

    "&:hover": {
      background: "rgba(255, 186, 69, 0.85)",
    },
  },

  // widthbox: {
  //   width: "40%",
  // },
  widthbox: {
    width: "49%",
    "@media (max-width:1200px)": {
      width: "100%",
    },
  },

  button: {
    "&:hover": {
      background: "#FFAF4A",
      color: "#FFFFFF",
      opacity: 0.8,
    },
  },

  exitbutton: {
    "&:hover": {
      background: "#F9FAFB",
      color: "#1D2939",
      opacity: 0.8,
    },
  },

  container: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    width: "49%",

    "@media (max-width:1300px)": {
      width: "auto",
    },
  },
  boxWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    border: "1px solid #D0D5DD",
    borderRadius: "8px",
    padding: "8px 12px",
    backgroundColor: "#fff",
    width: "100%",
    height: "48px",
  },
  selectBilling: {
    width: "73px",
    minWidth: "73px",
    fontSize: "16px",
    color: "#181D27",
  },
  inputField: {
    flex: 1,
    fontSize: "14px",
    border: "none",
    padding: "0",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    // width:'100%'
    // width: "min-content",
    // justifyContent:'flex-end'
  },

  servicesbox: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
  },

  boxsize: {
    width: "25px",
    // height:'10px',
    background: "#FFAF4A",
    padding: "2px 8px",
    borderRadius: "16px",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
  },

  addbtn: {
    display: "flex",
    justifyContent: "flex-end !important",
    marginTop: "18px",
    gap: "20px",
  },
}));
// const bgColor = "#D9D9D9";

const bgColor = "#FFFFFF";

const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 15px",
      // height:'48px',
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      backgroundColor: bgColor,
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 11px",

      backgroundColor: bgColor,
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#94A3B8"} size={20} />}
        rightSectionWidth={25}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

function AddProvider({ state, setState, returnedFacility }) {
  console.log("🚀 ~ AddProvider ~ returnedFacility:", returnedFacility);
  console.log("🚀 state ===================>:", state);
  const { classes } = useStyles();

  const { profile } = useSelector((state) => state?.profile);
  const allfacilty = useSelector((state) => state.facility);
  const { allservicecode } = useSelector((state) => state?.servicecode);
  // const { allproccode } = useSelector((state) => state?.servicecode);
  const [selectedCode, setSelectedCode] = useState("");
  const [provider, setProvider] = useState(null);
  console.log("🚀 ~ AddProvider ~ provider:", provider);
  // const [serviceValue, setServiceValue] = useState(null);
  const [knownIllness, setKnownIllness] = useState([]);
  const [knownIllnessField, setKnownIllnessField] = useState({
    servicetitle: "",
    servicenumber: "",
    servicechargetype: "",
    servicechargeNumber: "",
  });
  // const allproviderservices = useSelector(
  //   (state) => state?.servicecode?.allproviderservices?.allproviderservices
  // );

  const [isEditMode, setIsEditMode] = useState(false);

  // const handleChangeDiagnosis = () => {
  //   if (
  //     !knownIllnessField.servicetitle ||
  //     !knownIllnessField.servicenumber ||
  //     !knownIllnessField.servicechargetype ||
  //     !knownIllnessField.servicechargeNumber
  //   ) {
  //     showError("Missing or empty fields", 400);
  //     return;
  //   }
  //   // Create an object with the values of the fields
  //   const newDiagnosis = {
  //     servicetitle: knownIllnessField.servicetitle,
  //     servicenumber: knownIllnessField.servicenumber,
  //     servicechargetype: knownIllnessField.servicechargetype,
  //     servicechargeNumber: knownIllnessField.servicechargeNumber,
  //   };

  //   // Add the new diagnosis object to the knownIllness array
  //   setKnownIllness([...knownIllness, newDiagnosis]);
  //   console.log("knownIllness", knownIllness);

  //   // Clear the form fields
  //   setKnownIllnessField({
  //     servicetitle: "",
  //     servicenumber: "",
  //     servicechargetype: "",
  //     servicechargeNumber: "",
  //   });
  // };

  // Handle removing a diagnosis from the list
  // const removeDiagnosis = (index) => {
  //   let temp = knownIllness?.filter((_, i) => i !== index);
  //   setKnownIllness(temp);
  // };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setKnownIllnessField({ ...knownIllnessField, [name]: value });
  // };

  // const handleChange = (e, option) => {
  //   console.log("======>", e, e.target, option)
  //   const { name, value } = e.target;
  //   setKnownIllnessField((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  // };

  // const handleChange = (e, option) => {
  //   // Check if event is from SelectBox or CustomTextInput
  //   const { name, value } = e.target || option;

  //   console.log("e", e);
  //   console.log("option", option);

  //   // Update the state based on the field name and value
  //   setKnownIllnessField((prevState) => ({
  //     ...prevState,
  //     [name]: value, // Dynamically update the field with the name provided
  //   }));
  // };

  // const handleChange = (name, value) => {
  //   setKnownIllnessField((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  // };

  const handleSelectChange = (selectedOption) => {
    const selectedItem = allservicecode?.servicescode?.find(
      (item) => item.id === selectedOption
    );
    if (selectedItem) {
      setSelectedCode(selectedItem);
    }
  };

  const form = useForm({
    initialValues: {
      name: "",
      phone: "",
      taxonomy: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      zipcode: "",
      federaltaxtype: "",
      federaltaxNumber: "",
      billingindentifiertype: "",
      billingindentifierNumber: "",
      providertype: "",
      // servicetitle: "",
      // servicenumber: "",
      // servicechargeNumber: "",
    },
  });

  const [currentStep, setCurrentStep] = useState(0);

  // console.log("allproccode", allproccode);

  const nextbtn = () => {
    console.log("currentStep", currentStep);

    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    } else {
      // setAddclient(false);
    }
  };

  // Define content for each step
  const renderContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <Accordion defaultValue="business-info">
              <Accordion.Item
                style={{
                  background: "#FFF",
                  borderRadius: "16px",
                  border: "1px solid #E5E5E5",
                }}
                value="business-info"
              >
                <Accordion.Control>
                  <Text ff={"Inter"} fz={16} fw={600} color="#3F3F46">
                    Business Information
                  </Text>
                </Accordion.Control>
                <Accordion.Panel>
                  <form>
                    <Box className={classes.addbox}>
                      {/* <Text
                  style={{ marginBottom: "32px" }}
                  ff={"Inter"}
                  fz={16}
                  fw={600}
                  color="#171717"
                >
                  Business Information
                </Text> */}

                      <div className={classes.formRow}>
                        <Box className={classes.widthbox}>
                          <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                            Provider Type
                          </Text>
                          <CustomSelectBox
                            id="billing-type"
                            placeholder={"Type"}
                            withAsterisk
                            data={[
                              { value: "facility", label: "Facility" },
                              { value: "individual", label: "Individual" },
                            ]}
                            {...form.getInputProps("providertype")}
                          />
                        </Box>
                        <Box className={classes.widthbox}>
                          <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                            Provider Name
                          </Text>

                          {/* medication name */}
                          <CustomTextInput
                            id="medication-name"
                            // label={"Facility Name"}
                            size="sm"
                            // placeholder={"Enter Medication Name"}
                            // {...form.getInputProps("medicationName")}
                            withAsterisk
                            // disabled={isPreview}
                            {...form.getInputProps("name")}
                          />
                        </Box>
                      </div>

                      <div className={classes.formRow}>
                        <Box className={classes.container}>
                          <Text ff="Inter" fz={14} fw={500} color="#344054">
                            Phone Number
                          </Text>

                          <Box className={classes.boxWrapper}>
                            <Select
                              className={classes.selectBilling}
                              rightSection={
                                <IconChevronDown color={"#94A3B8"} size={20} />
                              }
                              id="billing-type"
                              placeholder="Type"
                              withAsterisk
                              variant="unstyled"
                              value={"+1"}
                              readOnly
                              data={[{ value: "+1", label: "+1" }]}
                              onChange={(value) =>
                                form.setFieldValue(
                                  "phone",
                                  value + form?.values?.phone?.slice(2)
                                )
                              }
                            />

                            <TextInput
                              className={classes.inputField}
                              id="billing-name"
                              type="text"
                              size="sm"
                              placeholder="000-000-000"
                              withAsterisk
                              variant="unstyled"
                              onChange={(e) =>
                                form.setFieldValue(
                                  "phone",
                                  form.values?.phone?.substring(0, 2) +
                                    e.target.value
                                )
                              }
                              {...form.getInputProps("phone")}
                            />
                          </Box>
                        </Box>

                        <Box className={classes.widthbox}>
                          <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                            Place of Service Name
                          </Text>
                          <Box className={classes.boxnumber}>
                            <CustomSelectBox
                              id="billing-type"
                              placeholder={"Type"}
                              withAsterisk
                              searchable
                              data={(allservicecode &&
                              allservicecode.servicescode
                                ? allservicecode.servicescode
                                : []
                              )

                                .map((item) => ({
                                  value: item?.id,
                                  label: item?.name,
                                }))

                                .sort((a, b) => a.label.localeCompare(b.label))}
                              value={selectedCode?.id}
                              onChange={handleSelectChange}
                              // {...form.getInputProps("serviceCode")}
                            />
                            {/* 
                        <Box className={classes.line}></Box> */}
                          </Box>
                        </Box>
                      </div>

                      <Box className={classes.mt19}>
                        <div className={classes.formRow}>
                          <Box className={classes.widthbox}>
                            <Text ff={"Inter"} fz={14} fw={500} color="#414651">
                              Code
                            </Text>
                            <CustomSelectBox
                              placeholder={"Number"}
                              withAsterisk
                              searchable
                              data={(allservicecode &&
                              allservicecode.servicescode
                                ? allservicecode.servicescode
                                : []
                              )
                                .map((item) => ({
                                  value: item?.id,
                                  label: item?.code,
                                }))
                                .sort((a, b) => {
                                  const numA = Number(a.label);
                                  const numB = Number(b.label);
                                  return numA - numB;
                                })}
                              value={selectedCode?.id}
                              onChange={handleSelectChange}
                            />
                          </Box>

                          <Box
                            className={`${classes.mt19} ${classes.widthbox}`}

                            // className={classes.mt19 }
                          >
                            <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                              Facility
                            </Text>
                            <CustomSelectBox
                              id="billing-type"
                              withAsterisk
                              data={
                                returnedFacility
                                  ? allfacilty?.allFacilities?.facilities
                                      ?.filter((f) => f.id === returnedFacility)
                                      ?.map((f) => ({
                                        value: f,
                                        label: f.name,
                                      })) || []
                                  : allfacilty?.allFacilities?.facilities?.map(
                                      (item) => ({
                                        value: item.id,
                                        label: item.name,
                                      })
                                    ) || []
                              }
                              // data={
                              //   returnedFacility
                              //     ? [
                              //         {
                              //           value: returnedFacility?.id,
                              //           label: returnedFacility?.name,
                              //         },
                              //       ]
                              //     : (
                              //         allfacilty?.allFacilities?.facilities ||
                              //         []
                              //       ).map((item) => ({
                              //         value: item,
                              //         label: item?.name,
                              //       }))
                              // }
                              // data={(allfacilty &&
                              // allfacilty?.allFacilities?.facilities
                              //   ? allfacilty?.allFacilities?.facilities
                              //   : []
                              // ).map((item) => ({
                              //   value: item,
                              //   label: item?.name,
                              // }))}
                              value={provider}
                              onChange={(value) => setProvider(value)}
                            />
                          </Box>
                        </div>

                        <div className={classes.formRow}>
                          <Box className={classes.container}>
                            <Text ff="Inter" fz={14} fw={500} color="#344054">
                              Federal Tax ID
                            </Text>

                            <Box className={classes.boxWrapper}>
                              <Select
                                className={classes.selectBilling}
                                rightSection={
                                  <IconChevronDown
                                    color={"#94A3B8"}
                                    size={20}
                                  />
                                }
                                id="billing-type"
                                placeholder="Type"
                                withAsterisk
                                variant="unstyled"
                                data={[
                                  { value: "SSN", label: "SSN" },
                                  { value: "EIN", label: "EIN" },
                                ]}
                                {...form.getInputProps("federaltaxtype")}
                              />

                              <TextInput
                                className={classes.inputField}
                                id="billing-name"
                                type="number"
                                size="sm"
                                placeholder="000-000-000"
                                withAsterisk
                                variant="unstyled"
                                {...form.getInputProps("federaltaxNumber")}
                              />
                            </Box>
                          </Box>

                          <Box className={classes.widthbox}>
                            <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                              Taxonomy/Speciality
                            </Text>

                            <CustomTextInput
                              id="medication-name"
                              // label={"Taxonomy/Speciality"}
                              size="sm"
                              // placeholder={"Enter Medication Name"}
                              // {...form.getInputProps("medicationName")}
                              withAsterisk
                              {...form.getInputProps("taxonomy")}
                              // disabled={isPreview}
                            />
                          </Box>

                          {/* Second Box */}
                        </div>

                        <Box
                          // style={{ width: "100%" }}
                          className={classes.container}
                        >
                          <Text ff="Inter" fz={14} fw={500} color="#344054">
                            Billing Identifier
                          </Text>

                          <Box className={classes.boxWrapper}>
                            <Select
                              className={classes.selectBilling}
                              rightSection={
                                <IconChevronDown color={"#94A3B8"} size={20} />
                              }
                              id="billing-type"
                              placeholder="Type"
                              withAsterisk
                              variant="unstyled"
                              data={[
                                { value: "NPI", label: "NPI" },
                                { value: "#", label: "#" },
                              ]}
                              {...form.getInputProps("billingindentifiertype")}
                            />

                            <TextInput
                              className={classes.inputField}
                              id="billing-name"
                              type="number"
                              size="sm"
                              placeholder="000-000-000"
                              withAsterisk
                              variant="unstyled"
                              {...form.getInputProps(
                                "billingindentifierNumber"
                              )}
                            />
                          </Box>
                        </Box>

                        <Text
                          style={{ marginTop: "10px" }}
                          ff={"Inter"}
                          fz={14}
                          fw={500}
                          color="#344054"
                        >
                          Address 1
                        </Text>

                        {/* medication name */}
                        <CustomTextInput
                          id="medication-name"
                          // label={"Facility Name"}
                          size="sm"
                          // placeholder={"Enter Medication Name"}
                          // {...form.getInputProps("medicationName")}
                          withAsterisk
                          {...form.getInputProps("address")}
                          // disabled={isPreview}
                        />
                      </Box>

                      <Box className={classes.mt19} mt={10}>
                        <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                          Address 2
                        </Text>

                        {/* medication name */}
                        <CustomTextInput
                          id="medication-name"
                          // label={"Facility Name"}
                          size="sm"
                          // placeholder={"Enter Medication Name"}
                          // {...form.getInputProps("medicationName")}
                          {...form.getInputProps("address2")}
                          withAsterisk
                          // disabled={isPreview}
                        />
                      </Box>

                      <div
                        style={{ marginTop: "19px" }}
                        className={classes.formRow}
                      >
                        <Box className={classes.widthbox}>
                          <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                            City
                          </Text>

                          {/* medication name */}
                          <CustomTextInput
                            id="medication-name"
                            // label={"Facility Name"}
                            {...form.getInputProps("city")}
                            size="sm"
                            // placeholder={"Enter Medication Name"}
                            // {...form.getInputProps("medicationName")}
                            withAsterisk
                            // disabled={isPreview}
                          />
                        </Box>

                        <Box className={classes.widthbox}>
                          <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                            State
                          </Text>

                          <CustomSelectBox
                            id="state"
                            size="sm"
                            withAsterisk
                            data={Array.from(
                              new Set(stateZipCodes?.map((obj) => obj.ste_name))
                            )
                              .sort()
                              .map((ste_name) => ({
                                value: ste_name,
                                label: ste_name,
                              }))}
                            {...form.getInputProps("state")}
                            searchable
                          />
                        </Box>
                      </div>

                      <div
                        style={{ marginTop: "19px" }}
                        className={classes.formRow}
                      >
                        <Box className={classes.widthbox}>
                          <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                            Zip Code
                          </Text>

                          <CustomTextInput
                            id="zip-code"
                            type="number"
                            // label={"Facility Name"}
                            {...form.getInputProps("zipcode")}
                            size="sm"
                            // placeholder={"Enter Medication Name"}
                            // {...form.getInputProps("medicationName")}
                            withAsterisk
                            // disabled={isPreview}
                          />
                        </Box>
                      </div>
                    </Box>
                  </form>
                </Accordion.Panel>
              </Accordion.Item>
            </Accordion>

            <Accordion style={{ marginTop: "24px" }}>
              <Accordion.Item
                style={{
                  background: "#FFF",
                  borderRadius: "16px",
                  border: "1px solid #E5E5E5",
                }}
                value="provider-service-details"
              >
                <Accordion.Control>
                  <Box className={classes.servicesbox}>
                    {knownIllness.length > 0 ? (
                      <img
                        width={20}
                        height={20}
                        // style={{ position: "relative", top: "29%" }}
                        src="/assets/images/Check icon.png"
                        alt="check-icon"
                      />
                    ) : null}

                    <Text ff={"Inter"} fz={16} fw={600} color="#171717">
                      Provider Service Details
                    </Text>

                    {knownIllness.length > 0 ? (
                      <Box className={classes.boxsize}>
                        <Text
                          ta="center"
                          ff={"Inter"}
                          fz={12}
                          fw={500}
                          color="#000"
                        >
                          {knownIllness?.length}
                        </Text>
                      </Box>
                    ) : null}
                  </Box>
                </Accordion.Control>
                <Accordion.Panel>
                  <form>
                    <ProviderServiceSearch
                      existingServices={knownIllness}
                      setExistingServices={setKnownIllness}
                      activeService={knownIllnessField}
                      setActiveService={setKnownIllnessField}
                      isEditMode={isEditMode}
                      setIsEditMode={setIsEditMode}
                    />
                  </form>
                </Accordion.Panel>
              </Accordion.Item>
            </Accordion>
          </>
        );

      default:
        return null;
    }
  };

  const onSave = async (_) => {
    const values = form.values;
    console.log("values", values);
    let missingFields = [];
    try {
      if (!selectedCode) missingFields.push("Place of Service Name");
      Object.entries(values)
        .filter(([key, _]) => key !== "address2")
        .forEach(([key, value]) => !value && missingFields.push(key));
      if (form.values.providertype === "facility" && !provider)
        missingFields.push("Provider");
      if (knownIllness.length < 1) missingFields.push("Service");
      if (missingFields.length > 0) {
        await swal({
          title: "Please fill out the following fields",
          text: missingFields.join(", "),
          icon: "warning",
          dangerMode: true,
        });
        return;
      }

      const selectedState = values.state?.trim();
      const enteredZipCode = values.zipcode?.trim();
      if (selectedState && enteredZipCode) {
        const stateZipCodeEntries = stateZipCodes.filter(
          (entry) => entry.ste_name === selectedState
        );

        const isZipValid = stateZipCodeEntries.some(
          (entry) => entry.zip_code === enteredZipCode
        );

        if (!isZipValid) {
          await swal({
            title: "Invalid Zip Code",
            text: `The zip code you entered is not valid for ${selectedState}. Please enter a valid zip code.`,
            icon: "warning",
            dangerMode: true,
          });
          return;
        }
      }

      // if (
      //   !selectedCode ||
      //   knownIllness.length < 1 ||
      //   Object.entries(values)
      //     .filter(([key, _]) => key !== "address2")
      //     .some(([_, value]) => !value)
      // ) {
      //   await swal({
      //     title: "Please fill out the following fields",
      //     icon: "warning",
      //     dangerMode: true,
      //   });
      //   return;
      // }

      // const selectedState = values.state?.trim();
      // const enteredZipCode = String(values.zipcode)?.trim();
      const {
        federaltaxtype,
        federaltaxNumber,
        billingindentifiertype,
        billingindentifierNumber,
        ...restValues
      } = values;

      let payload = {
        ...restValues,
        federalTaxID: {
          type: federaltaxtype,
          number: federaltaxNumber,
        },
        billingIdentifier: {
          type: billingindentifiertype,
          number: billingindentifierNumber,
        },
        services: knownIllness?.map((service) => {
          return {
            servicetitle: service?.servicetitle,
            servicenumber: service?.servicenumber,
            servicechargetype: service?.servicechargetype,
            servicechargeNumber: service?.servicechargeNumber,
          };
        }),
        serviceCode: selectedCode?.id,
        admin: profile.user.id,
        facilityId: provider?.id || provider,
      };

      console.log("payload", payload);

      let addFacilityResponse = await createBillingProvider(payload);

      console.log("addFacilityResponse", addFacilityResponse);

      if (addFacilityResponse?.status === 200) {
        let payload = {
          page: 1,
        };

        getBillingProvider(payload);
        swal({
          title: `provider addded successfully`,
          text: "provider addded successfully",
          dangerMode: false,
        });

        form?.reset();
        // setKnownIllness=[]

        handleClose();
      }
    } catch (error) {
      console.log("error", error);
    }
    // console.log("values", values);

    // let payload={
    //   values,
    //   admin:profile.user.id
    // }

    //  await createfa(
    //     payload
    //   )

    // console.log('state here',state);

    // await backbtn()

    // setState(state => ({
    //   ...state,
    //   client: false,
    //   payer: true,
    //   provider: false,
    //   addProvider: false,
    //   addClient: false,
    //   addPayer: false,
    // }));

    // setState(prevState => ({
    //   ...prevState,
    //   client: false,
    //   payer: true,
    //   provider: false,
    //   addProvider: false,
    //   addClient: false,
    //   addPayer: false,
    // }))

    // console.log('state here after',state);

    // addFacilityType({ name: values?.type });

    // form?.reset();
    // close();
  };
  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      addProvider: false,
    }));
  };

  return (
    <Drawer
      offset={8}
      radius="md"
      size="50%"
      // style={{ backgroundColor: "#D0D5DD  !important" }}
      // bg={"#F5F5F5"}

      sx={{
        ".mantine-1fholi4": {
          color: "#000",
        },
        ".mantine-1fholi4:hover": {
          color: "#FFAF4A",
        },
      }}
      zIndex={1000}
      // title="Add Provider"
      // sx={{
      //    backgroundColor: "red !important",
      // }}
      title={
        <span style={{ fontSize: "24px", fontWeight: "700", color: "#000" }}>
          Add Provider
        </span>
      }
      opened={state.addProvider}
      onClose={handleClose}
      className={classes.customBox}
      position="right"
      scrollAreaComponent={ScrollArea.Autosize}
      overlayProps={{ backgroundOpacity: 2.5, blur: 4 }}
    >
      <Box className={classes.mainbox}>{renderContent()}</Box>
      <Box className={classes.addbtn}>
        <Box>
          <Button
            className={classes.exitbutton}
            onClick={handleClose}
            variant="fixed"
            c="#1D2939"
            radius="md"
            size="md"
            bg="#FFF"
          >
            Cancel
          </Button>
        </Box>
        <Box>
          <Button
            className={classes.button}
            onClick={onSave}
            variant="fixed"
            // disabled={knownIllness.length <=0}
            c="#1D2939"
            radius="md"
            size="md"
            bg="#FFAF4A"
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}

export default AddProvider;
